export const REFRESH_CONFIG = {
  // 刷新间隔（毫秒）
  interval: 30 * 1000,
  // 最小刷新间隔（毫秒）
  minInterval: 5 * 1000,
  // 最大刷新间隔（毫秒）
  maxInterval: 300 * 1000,
  // 步长（毫秒）
  step: 5 * 1000,
  // 日志级别
  logLevel: 'info', // 'debug' | 'info' | 'warn' | 'error'
  // 是否显示时间戳
  showTimestamp: true,
  // 是否自动保存配置
  autoSave: true
}

// 保存配置到 localStorage
export const saveConfig = (config) => {
  localStorage.setItem('refreshConfig', JSON.stringify(config))
}

// 从 localStorage 加载配置
export const loadConfig = () => {
  const savedConfig = localStorage.getItem('refreshConfig')
  if (savedConfig) {
    return { ...REFRESH_CONFIG, ...JSON.parse(savedConfig) }
  }
  return REFRESH_CONFIG
}

// 格式化时间戳
export const formatTimestamp = () => {
  const now = new Date()
  return `[${now.toLocaleTimeString()}.${now.getMilliseconds().toString().padStart(3, '0')}]`
}

// 日志函数
export const logger = {
  debug: (message) => {
    if (REFRESH_CONFIG.logLevel === 'debug') {
      const timestamp = REFRESH_CONFIG.showTimestamp ? formatTimestamp() : ''
      console.debug(`${timestamp} ${message}`)
    }
  },
  info: (message) => {
    if (['debug', 'info'].includes(REFRESH_CONFIG.logLevel)) {
      const timestamp = REFRESH_CONFIG.showTimestamp ? formatTimestamp() : ''
      console.info(`${timestamp} ${message}`)
    }
  },
  warn: (message) => {
    if (['debug', 'info', 'warn'].includes(REFRESH_CONFIG.logLevel)) {
      const timestamp = REFRESH_CONFIG.showTimestamp ? formatTimestamp() : ''
      console.warn(`${timestamp} ${message}`)
    }
  },
  error: (message) => {
    const timestamp = REFRESH_CONFIG.showTimestamp ? formatTimestamp() : ''
    console.error(`${timestamp} ${message}`)
  }
} 